module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-ap-a0d2e2e4.png";